import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface StorageStore<T = string> {
  value: T;
  setValue: (v?: T) => void;
}
/* `export const useLocalStorage` 是一个创建具有两个属性的新 Zustand 存储的函数：`value` 和 `setValue`。 `value`
  属性使用默认值初始化（如果未提供），并且可以使用 `setValue` 函数进行更新。该存储还使用 Zustand 的“持久化”中间件持久保存到本地存储，这允许该存储在页面刷新时持久保存。
  `name` 属性指定存储在本地存储中的键，`storage` 属性指定要使用的存储类型（在这种情况下，`createJSONStorage` 用于将数据作为 JSON 存储在本地贮存）。 */
export const useLocalStorage = <T>(key: string, defaultValue?: T) => {
  return create(
    persist<StorageStore<T>>(
      (set, get) => ({
        value: (defaultValue || "") as T,
        setValue: (v?: T) => {
          return set({ value: v });
        },
      }),
      {
        name: key,
        storage: createJSONStorage(() => window.localStorage),
      },
    ),
  );
};

export const selectorLocalStorage = <T>(
  store: StorageStore<T>,
): [value: T, setValue: (v: T) => void] => [store.value, store.setValue];
